
export const roundTo = (value, precision) => {
  return +(Math.round(+value + "e+" + precision)  + "e-" + precision);
}